import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import React from 'react'

export const CreateCardFooter = ({ onCancel, form }) => {
  return (
    <Horizontal justifyContent={'flex-end'} className={'p-2'}>
      <GraviButton buttonText={'Cancel'} onClick={onCancel} className={'square-ish mr-4'} />
      <GraviButton buttonText={'Confirm'} onClick={() => form.submit()} className={'square-ish'} theme1 />
    </Horizontal>
  )
}
